export const SPECIALIST_CLINIC = '/';
export const SPECIALIST_DETAIL = '/specialist-detail';
export const CHANGE_SPECIALIST_DETAIL = '/change-specialist-detail';
export const DOCTOR_SEARCH = '/doctor-search';
export const GROUP_DOCTOR_LIST = '/group-doctor-list';
export const DEPARTMENT_SEARCH = '/department-search';
export const CLINIC_PAYMENT = '/clinic-payment';
export const FAST_INQUIRY = '/fast-inquiry-pay';
export const FOLLOWED_SPECIALIST = '/followed-specialist';
export const RECOMMEND_SPECIALIST = '/recommend-specialist';
export const DEPARTMENT_SPECIALIST = '/department-specialist';
export const HOSPITAL_LIST = '/hospital-list';
export const HOSPITAL_INTRO = '/hospital-intro';
export const HOSPITAL_DETAIL = '/hospital-detail';

export const PAY = '/pay';
export const PAY_SUCCESS = '/pay/success';
export const PAY_FAIL = '/pay/fail';

const getPathEnv = () => {
  const { pathname } = window.location;
  if (/qatest-newc-dev/.test(pathname)) {
    return 'qatest-newc-dev/';
  }
  if (/qatest-newc-qa/.test(pathname)) {
    return 'qatest-newc-qa/';
  }
  return '';
};

const IM = `${process.env.VUE_APP_STATIC}/${process.env.VUE_APP_PATH || 'f2e'}/kangm-customer-h5-im/${getPathEnv()}#/chat/chatCore`;
export const getIM = (id: number | string) => `${IM}?to=${id}`;
export const WEALTH_CENTER = `${process.env.VUE_APP_STATIC}/f2e/patient-mall/#/wealth-center`;

const PAYMENT = `${process.env.VUE_APP_STATIC}/f2e/patient-mall/#/payment-clinic`;
export const getPayment = (orderId: number, url: string) => `${PAYMENT}?orderId=${orderId}&successUrl=${url}`;

const FAST_INQUIRY_IM = `${process.env.VUE_APP_STATIC}/${process.env.VUE_APP_PATH || 'f2e'}/kangm-customer-h5-im/${getPathEnv()}#/quick-ask`;
export const getFastInquiryIM = (id: number, channel?: number) => {
  const url = FAST_INQUIRY_IM;
  if (channel) {
    return `${url}?channel=${channel}`;
  }
  return url;
};

export const fastInquiryEntry = (channel?: number) => {
  const url = `${process.env.VUE_APP_STATIC}/${process.env.VUE_APP_PATH || 'f2e'}/kangm-customer-h5-im/${getPathEnv()}#/quick-ask`;
  if (channel) {
    return `${url}?channel=${channel}`;
  }
  return url;
};

export const CONSULTED_LIST = `${process.env.VUE_APP_STATIC}/${process.env.VUE_APP_PATH || 'f2e'}/more-project/${getPathEnv()}patient-consulted-list/#/`;
